import { addPx } from './addPx';

export const stylesHelpers = {
    addPx,
};
